import { GraphQLNonNull, GraphQLObjectType, GraphQLBoolean } from 'graphql'
import { ContrastGraphQLFieldConfig } from '../'
import { Context } from '../shared'

const reportingStatusType = new GraphQLObjectType({
  name: 'ReportingStatus',
  fields: () => ({
    enabled: {
      description: 'Whether or not async reporting is enabled',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})

export const reportingStatus: ContrastGraphQLFieldConfig<
  any,
  Context,
  {},
  { readonly enabled: boolean }
> = {
  type: new GraphQLNonNull(reportingStatusType),
  description: 'Reporting feature status',
  args: {},
  async resolve(
    _source,
    _args,
    context
  ): Promise<{ readonly enabled: boolean }> {
    const { enabled } = await context.connector.get('reporting/status')

    return {
      enabled
    }
  }
}
